module.exports = __webpack_public_path__ + "static/legend-size-dont-9a08e13ac63cfb791eb70be4fdcf9a32.png";